import { logger } from '../../../../utils/logger';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type JssipUA = any;

export function getVoiceInternalsFromWindow(): {
  voiceClient: unknown;
  webRtcService: unknown;
  audioCode: unknown;
  jssipUA: JssipUA | undefined;
} {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const globalWindow = window as any;
  const voiceClient = globalWindow.__voiceClient;
  const webRtcService = voiceClient?.webRtcService;
  const audioCode = webRtcService?.audioCode;
  const jssipUA = audioCode?.jssipUA;

  return { voiceClient, webRtcService, audioCode, jssipUA };
}

export function buildConnectionSnapshot(
  voiceClient: unknown,
  webRtcService: unknown,
  audioCode: unknown,
  jssipUA: JssipUA | undefined
): Record<string, unknown> {
  return {
    hasVoiceClient: !!voiceClient,
    hasWebRtcService: !!webRtcService,
    hasAudioCode: !!audioCode,
    hasJssipUA: !!jssipUA,
    audioCodeIsConnected: (webRtcService as { audioCodeIsConnected?: boolean })
      ?.audioCodeIsConnected,
    jssipConnected: jssipUA?.isConnected?.(),
    jssipRegistered: jssipUA?.isRegistered?.(),
  };
}

export function logJssipInternals(jssipUA: JssipUA): void {
  try {
    const registrator = jssipUA._registrator;
    if (registrator) {
      logger.debug('[CXone WATCHER]   Registrator state:', {
        registered: registrator._registered,
        registering: registrator._registering,
        expires: registrator._expires,
      });
    }

    const transport = jssipUA._transport;
    if (transport) {
      logger.debug('[CXone WATCHER]   Transport state:', {
        isConnected: transport.isConnected?.(),
        via_transport: transport.via_transport,
      });
    }
  } catch {
    // Ignore errors accessing internals
  }
}

export function logJssipRegistrationFailure(jssipUA: JssipUA): void {
  try {
    logger.error('[CXone WATCHER] UA internal state:', {
      status: jssipUA._status,
      registrator: jssipUA._registrator
        ? {
            registered: jssipUA._registrator._registered,
            registering: jssipUA._registrator._registering,
            reg_id: jssipUA._registrator._reg_id,
          }
        : 'none',
    });
  } catch {
    // Ignore
  }
}
